import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  public async downloadFile(data: any, fileName: string) {
    const downloadedFile = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const fileURL = URL.createObjectURL(downloadedFile);
    const anchorTag = document.createElement('a');
    anchorTag.href = fileURL;
    anchorTag.download = fileName;
    anchorTag.click();
    //window.open(fileURL, '_blank');
  }
  public async downloadPdf(data: any, fileName:string) {
    const downloadedFile = new Blob([data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(downloadedFile);
    const anchorTag = document.createElement('a');
    anchorTag.href = fileURL;
    anchorTag.download = fileName;
    anchorTag.target = '_blank';
    anchorTag.click();
    //window.open(fileURL, '_blank');
  }
  public async downloadTextFile(data: any, fileName: string) {
    const downloadedFile = new Blob([data], {
      type: 'text/plain',
    });
    const fileURL = URL.createObjectURL(downloadedFile);
    const anchorTag = document.createElement('a');
    anchorTag.href = fileURL;
    anchorTag.download = fileName;
    anchorTag.click();
    //window.open(fileURL, '_blank');
  }
}
